/**
 * Combined Find / Offer Help page.
 * Replaces two separate top-nav entries with a single "Find / Offer Help"
 * hub that hosts both experiences as tabs — reduces nav clutter.
 * Legacy routes /find-help and /offer-help continue to work (see App.js).
 */
import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import FindHelp from "./FindHelp";
import OfferHelp from "./OfferHelp";
import { Search, HandHelping } from "lucide-react";

export default function FindOfferHelp() {
  const [params, setParams] = useSearchParams();
  const initial = params.get("mode") === "offer" ? "offer" : "find";
  const [tab, setTab] = useState(initial);

  useEffect(() => {
    const p = new URLSearchParams(params);
    p.set("mode", tab);
    setParams(p, { replace: true });
    // eslint-disable-next-line
  }, [tab]);

  return (
    <div data-testid="find-offer-help-page">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 pt-16 pb-4">
        <div className="overline mb-3" style={{ color: "var(--wofy-primary)" }}>
          FIND / OFFER HELP
        </div>
        <h1 className="font-display text-4xl md:text-5xl leading-tight max-w-3xl">
          Two paths, one movement — find the help you need, or share the help you have.
        </h1>
        <p className="mt-4 text-sm max-w-2xl" style={{ color: "var(--wofy-text-soft)" }}>
          Switch between the two experiences with a single tap. Every request and every
          offer is verified and lands on the same trusted platform.
        </p>

        <div
          className="mt-8 inline-flex rounded-full border p-1"
          style={{ borderColor: "var(--wofy-border)", background: "var(--wofy-surface)" }}
        >
          <button
            data-testid="foh-tab-find"
            onClick={() => setTab("find")}
            className="px-5 py-2 rounded-full text-sm font-medium inline-flex items-center gap-2 transition-colors"
            style={
              tab === "find"
                ? { background: "var(--wofy-primary)", color: "white" }
                : { color: "var(--wofy-text-soft)" }
            }
          >
            <Search className="w-4 h-4" /> Find Help
          </button>
          <button
            data-testid="foh-tab-offer"
            onClick={() => setTab("offer")}
            className="px-5 py-2 rounded-full text-sm font-medium inline-flex items-center gap-2 transition-colors"
            style={
              tab === "offer"
                ? { background: "var(--wofy-primary)", color: "white" }
                : { color: "var(--wofy-text-soft)" }
            }
          >
            <HandHelping className="w-4 h-4" /> Offer Help
          </button>
        </div>
      </div>

      {tab === "find" ? <FindHelp /> : <OfferHelp />}
    </div>
  );
}
